// extracted by mini-css-extract-plugin
export default {"Form":"_6tX0b5oXEtuqSw69j5d1PwTWGobU3aJc0wfe-udikPm","columns":"_8DzvjnUCTsMrsuJzjElR1k596JIUMCfbTcpDMuo3xpU","bad":"_75HYcTEMchc1vLzwFndY2Nz5au1DNsg3FcxB3jt8nPk"};